const Accordion = {
  defaultProps: {
    variant: 'filled',
    radius: 'xs',
  },
  styles: (theme, _params) => ({
    control: {
      color: theme.colors.default[9],
      backgroundColor: theme.colors.accentSubtle[1],
      fontWeight: 400,
      fontSize: 18,
    },
  }),
};

export default Accordion;
